// @ts-ignore
export const all = (state) => state.all;
// @ts-ignore
export const visibility = (state) => state.doctorsVectorLayer ? state.doctorsVectorLayer.getVisible() : true;
// @ts-ignore
export const layer = (state) => state.doctorsVectorLayer;
// @ts-ignore
export const hauptfach = (state) => state.hauptfach;
// @ts-ignore
export const supercluster = (state) => state.supercluster;
